import { combineEpics } from 'redux-observable';
import { RootAction, RootState } from 'typesafe-actions';

import commonEpics from 'common/redux';

import assetsEpics from 'components/AssetsList/redux';
import ordersEpics from 'components/Orders/list/redux';

import derivativesEpics from 'views/derivatives/redux';
import earnEpics from 'views/earn/redux';
import exchangeEpics from 'views/exchange/redux';
import stocksEpics from 'views/stocks/redux';
import walletEpics from 'views/wallet-new/redux';

import socketEpics from 'blocks/SocketProvider/redux';

export const rootEpic = combineEpics<RootAction, RootAction, RootState, { api: any }>(
  walletEpics,
  assetsEpics,
  commonEpics,
  ordersEpics,
  exchangeEpics,
  socketEpics,
  derivativesEpics,
  earnEpics,
  stocksEpics,
);
